module.exports = __webpack_public_path__ + "static/img/g-wchat.be49e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/g-wchat.png
// module id = 7PW7
// module chunks = 0